// spinner.interceptor.ts
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SKIP_SPINNER, SpinnerService } from './spinner.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Locked flows (e.g. dashboard reorder) own the overlay — do not toggle per request.
    // Auth login/signup use delayed app-please-wait instead of the global spinner.
    if (
      this.spinnerService.isSpinnerLocked ||
      req.context.get(SKIP_SPINNER) ||
      this.isAuthFlowWithoutSpinner(req.url) ||
      this.isBackgroundNotificationRequest(req.url)
    ) {
      return next.handle(req);
    }

    this.spinnerService.httpRequestStarted();

    return next.handle(req).pipe(
      finalize(() => {
        this.spinnerService.httpRequestEnded();
      })
    );
  }

  private isAuthFlowWithoutSpinner(url: string): boolean {
    return (
      url.includes('/auth/login') ||
      url.includes('/auth/reset') ||
      url.includes('/auth/password-reset-complete') ||
      url.includes('/auth/user-requests/') ||
      url.includes('/auth/b2c-signup/')
    );
  }

  /** Notification list/badge refreshes & mobile-banner HTTP poll — no full-page spinner. */
  private isBackgroundNotificationRequest(url: string): boolean {
    return url.includes('/AD/notifications');
  }
}
